import React from 'react';
import { OteGameOtePlayerOteTeam } from '~/src/models/OteGameOtePlayerOteTeam';
import { OteGameOteTeam } from '~/src/models/OteGameOteTeam';
import { OteGame } from '../../models/OteGame';
import './BoxScore.scss';
import Periods from './Periods';
import TeamLeaders from './TeamLeaders';
import TeamStats from './TeamStats';

const BoxScore = ({
	game,
	players,
	awayGameTeam,
	homeGameTeam,
}: {
	game: OteGame;
	players: OteGameOtePlayerOteTeam[];
	awayGameTeam: OteGameOteTeam;
	homeGameTeam: OteGameOteTeam;
}) => {
	return (
		<div className="GameBoxScore">
			<div className={`PeriodsContainer`}>
				<Periods game={game} homeTeam={homeGameTeam} awayTeam={awayGameTeam} />
			</div>
			<div>
				<TeamLeaders game={game} players={players} homeGameTeam={homeGameTeam} awayGameTeam={awayGameTeam} />
			</div>
			<div>
				<TeamStats game={game} homeGameTeam={homeGameTeam} awayGameTeam={awayGameTeam} />
			</div>
		</div>
	);
};

export default BoxScore;
